import React from 'react';
import { connect } from 'react-redux';
import { noop } from '@prisjakt/ui-base';
import { headerClickEvent } from '../../../../actions/product';

import ErrorBoundary from '../../../../../../components/error-boundary';

import { ProductHeaderProps } from '../../types';

import * as S from './styles';

type DispatchProps = {
  dispatchHeaderClickEvent: (type: string) => void;
};
const ProductHeaderMobile = (props: ProductHeaderProps & DispatchProps) => {
  const { title, product } = props;

  if (!product) {
    return null;
  }

  return (
    <S.MobileHeader>
      <S.MainSection>
        <ErrorBoundary onError={noop}>
          {product && (
            <>
              {props.currentCampaign ? (
                <S.CampaignBadge
                  campaign={props.currentCampaign}
                  size="large"
                />
              ) : null}
              <S.ProductMedia
                name={product.name}
                media={product.media}
                category={product.category}
              />
            </>
          )}
        </ErrorBoundary>
        <S.DescriptionWrapper>
          <S.Title data-test="ProductTitle">{title}</S.Title>

          <S.ProductActionButtons
            product={product}
            buttonStyle="circle"
            horizontal
          />
        </S.DescriptionWrapper>
      </S.MainSection>
    </S.MobileHeader>
  );
};

const dispatchProps = {
  dispatchHeaderClickEvent: headerClickEvent,
};

export default connect(null, dispatchProps)(ProductHeaderMobile);
